import http from "../services/http/httpService";
import { getApiUrl } from "../services/http/httpService";

class BaseApp {
  constructor() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      this.production = false;
    } else {
      this.production = true;
    }

    this.windowLocationHash = window.location.hash;
    this.windowLocationHref = window.location.href;
    this.windowLocationHost = window.location.host;
    this.windowLocationHostname = window.location.hostname;
    this.windowLocationPathname = window.location.pathname;
    this.windowLocationProtocol = window.location.protocol;
    this.windowLocationOrigin = window.location.origin;
    this.navigatorAppName = navigator.appName;
    this.navigatorAppCodeName = navigator.appCodeName;
    this.navigatorPlatform = navigator.platform;
    this.navigatorCookieEnabled = navigator.cookieEnabled;
    this.navigatorProduct = navigator.product;
    this.navigatorAppVersion = navigator.appVersion;
    this.navigatorUserAgent = navigator.userAgent;
    this.navigatorLanguage = navigator.language;
    this.navigatorOnLine = navigator.onLine;
    this.navigatorJavaEnabled = navigator.javaEnabled();
  }

  validateIfLoggedIn() {
    return http.get(getApiUrl() + "/validateIfLoggedIn");
  }

  getBasename() {
    // return "/backend2-0.1";
    // return "/clockwork";
    return window.location.pathname;
  }

  logProperties() {
    console.log("production-mode", this.production);
    console.log("window.location.hash", this.windowLocationHash);
    console.log("window.location.href", this.windowLocationHref);
    console.log("window.location.host", this.windowLocationHost);
    console.log("window.location.hostname", this.windowLocationHostname);
    console.log("window.location.pathname", this.windowLocationPathname);
    console.log("window.location.protocol", this.windowLocationProtocol);
    console.log("window.location.origin", this.windowLocationOrigin);
    console.log("navigator.appName", this.navigatorAppName);
    console.log("navigator.appCodeName", this.navigatorAppCodeName);
    console.log("navigator.platform", this.navigatorPlatform);
    console.log("navigator.cookieEnabled", this.navigatorCookieEnabled);
    console.log("navigator.product", this.navigatorProduct);
    console.log("navigator.appVersion", this.navigatorAppVersion);
    console.log("navigator.userAgent", this.navigatorUserAgent);
    console.log("navigator.language", this.navigatorLanguage);
    console.log("navigator.onLine", this.navigatorOnLine);
    console.log("navigator.javaEnabled()", this.navigatorJavaEnabled);
  }
}

export default BaseApp;
